import React, { useState } from 'react';
import PropTypes from 'prop-types';

import styles from './RemoteOralExam.scss';
import { t } from '../../services/i18nService';
import apiService from '../../services/api/ApiService';
import sessionReader from '../../store/readHelpers/SessionReader';
import navigationService from '../../services/NavigationService';
import remoteOralExamService from '../../services/RemoteOralExamService';

const JoinController = ({ isInProgress }) => {
    const [isButtonDisabled, setButtonDisabled] = useState(false);
    const handleJoinButtonClick = () => {
        setButtonDisabled(true);
        const assessmentRunId = sessionReader.getAssessmentRunId(true);
        apiService.enterOralExamWaitingRoom(assessmentRunId)
            .then(() => {
                remoteOralExamService.setCandidateJoined();
                if (isInProgress) {
                    navigationService.navigateToRemoteOral();
                }
            })
            .catch(() => {
                setButtonDisabled(false);
            });
    };

    return (<div className={styles.description}>
        <p>{t('remoteOralExam.overview.description')}</p>
        <p>{t('remoteOralExam.overview.clickJoiningRoom')}</p>
        <p>
            <button className="btn default-btn" onClick={handleJoinButtonClick} disabled={isButtonDisabled}>
                {t('remoteOralExam.overview.joiningWaitingRoom')}
            </button>
        </p>
    </div>);
};

JoinController.propTypes = {
    isInProgress: PropTypes.bool.isRequired,
};

export default JoinController;
